import { useState } from 'react';
import { orderAllowedValuesFirst } from '../../../services/ConfigitService';
import { AutocompleteComponent } from './../AutocompleteComponent/AutocompleteComponent';
import { jsx as _jsx } from "react/jsx-runtime";
export var ConfigitAutocomplete = function (_a) {
    var id = _a.id, label = _a.label, options = _a.options, hasAllowedValues = _a.hasAllowedValues, handleSelect = _a.handleSelect, handleUnSelect = _a.handleUnSelect, disabled = _a.disabled, className = _a.className, preSelectedOption = _a.preSelectedOption;
    var optionArray = [];
    var _b = useState(preSelectedOption), selectedOption = _b[0], setSelectedOption = _b[1];
    if ((preSelectedOption === null || preSelectedOption === void 0 ? void 0 : preSelectedOption.name) !== (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name))
        setSelectedOption(preSelectedOption);
    var mapOptions = function (options) { var sortedOptions = orderAllowedValuesFirst(options); sortedOptions.forEach(function (optionValue) { optionArray.push({ value: optionValue.value, name: checkName(optionValue.name), incompatible: optionValue.incompatible }); }); return optionArray; };
    var checkName = function (value) { return value === undefined ? '' : value; };
    var updatedAutocompleteValue = function (option) { if (id) {
        if (id) {
            if (selectedOption && option === null)
                handleUnSelect(id);
            if (option && option.value)
                if (!selectedOption || selectedOption.value !== option.value) {
                    handleSelect(String(option.value));
                }
        }
        setSelectedOption(option ? option : {});
    } };
    return /*#__PURE__*/ _jsx(AutocompleteComponent, { id: id, className: className ? className : 'w-100', options: mapOptions(options), setCallback: updatedAutocompleteValue, defaultValue: checkName(preSelectedOption === null || preSelectedOption === void 0 ? void 0 : preSelectedOption.name), label: label });
};
